import { createContext, useContext } from 'react';
import type { Dictionary, Locale } from './registry.js';

export interface I18nValue {
  readonly locale: Locale;
  readonly t: Dictionary;
  /** Локали, доступные в этом бренде, в объявленном порядке. */
  readonly available: readonly Locale[];
  setLocale(locale: Locale): void;
  /** Приводит произвольную строку к локали бренда, иначе — к его локали по умолчанию. */
  resolveLocale(value?: string | null): Locale;
  formatDate(value: Date | number | string): string;
}

export const I18nContext = createContext<I18nValue | null>(null);

export function useI18n(): I18nValue {
  const value = useContext(I18nContext);
  if (!value) throw new Error('useI18n должен использоваться внутри I18nProvider');
  return value;
}
